import { type TourStep } from '../../types/project-tour.types';
import { StepIdsEnum } from './projects-tour-enums';

export const NUM_REQUIRED_PRODUCTS = 3;
export const MOBILE_LEFT_OFFSET = 16;
export const MOBILE_SIDEBAR_LEFT_OFFSET = 8;

const {
	TOUR_START,
	COPY_MOVE,
	COMPARE,
	ADD_TO_CART,
	NEW_GROUP,
	GROUP,
	SEARCH_FROM_PROJECTS,
	EDIT_PRODUCT,
	COMMENT,
	ORDERS_RETURNS,
	COMMUNICATION,
	PORTFOLIO,
	TOUR_END
} = StepIdsEnum;

const TOOLBAR_DEFAULTS: Pick<TourStep, 'title' | 'topOffset' | 'leftOffset' | 'verticalPosition'> = {
	title: 'Project Toolbar',
	topOffset: 12,
	leftOffset: -8,
	verticalPosition: 'bottom'
};

const GROUP_DEFAULTS: Pick<TourStep, 'title' | 'leftOffset' | 'verticalPosition'> = {
	title: 'Groups & Products',
	leftOffset: -8,
	verticalPosition: 'top'
};

const MANAGEMENT_DEFAULTS: Pick<TourStep, 'title' | 'leftOffset' | 'verticalPosition'> = {
	title: 'Project Management Tools',
	leftOffset: -289,
	verticalPosition: 'top'
};

export const TOUR_STEPS: TourStep[][] = [
	[
		{
			id: TOUR_START,
			title: 'Projects Tour',
			description: 'See what features we have to help you organize and manage your projects',
			leftOffset: -8,
			verticalPosition: 'bottom'
		},
		{
			id: COPY_MOVE,
			description: 'Copy and Move selected products and/or groups within this project or to other projects',
			...TOOLBAR_DEFAULTS
		},
		{
			id: COMPARE,
			description: 'Compare 2-4 selected products to see the differences and similarities between them',
			...TOOLBAR_DEFAULTS
		},
		{
			id: ADD_TO_CART,
			description: 'Add all selected products to your shopping cart',
			...TOOLBAR_DEFAULTS
		},
		{
			id: NEW_GROUP,
			description: 'Create New Group(s) to further organize your project',
			...TOOLBAR_DEFAULTS
		}
	],
	[
		{
			id: GROUP,
			description: 'A group helps you organize and categorize the products in your project',
			topOffset: 60,
			mobileTopOffset: 250,
			...GROUP_DEFAULTS
		},
		{
			id: SEARCH_FROM_PROJECTS,
			description: 'You can search our product catalog to add to your group directly from this page',
			topOffset: 176,
			mobileTopOffset: 415,
			...GROUP_DEFAULTS
		},
		{
			id: EDIT_PRODUCT,
			description: 'You can edit the product to adjust quantity, finish, and see related products',
			topOffset: 192,
			mobileTopOffset: 325,
			...GROUP_DEFAULTS
		},
		{
			id: COMMENT,
			description: 'Leave comments on products to streamline collaboration and communication within your project',
			topOffset: 192,
			mobileTopOffset: 325,
			...GROUP_DEFAULTS
		}
	],
	[
		{
			id: ORDERS_RETURNS,
			description: 'View all orders, returns and their status within your project',
			mobileDescription: 'Open the menu to view all orders, returns and their status within your project',
			mobileTopOffset: 193,
			...MANAGEMENT_DEFAULTS
		},
		{
			id: COMMUNICATION,
			description: "Invite others to collaborate on your project, access project comments, and see what's changed with notifications",
			mobileTopOffset: 347,
			...MANAGEMENT_DEFAULTS
		},
		{
			id: PORTFOLIO,
			description: 'Export spec sheets or a pdf presentation portfolio of your project',
			mobileTopOffset: 210,
			...MANAGEMENT_DEFAULTS
		},
		{
			id: TOUR_END,
			title: 'Try it out!',
			description: 'Organize your next project with Projects',
			leftOffset: -289,
			verticalPosition: 'top'
		}
	]
];
